import {useCheckConfirmationToken, CheckResult} from 'hooks/api/useCheckConfirmationToken'

export const useCheckInvitationConfirmationToken = (token?: string): CheckResult =>
  useCheckConfirmationToken('/api/invitation_confirmation', {params: {token}})
